export const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    opacity: '1',
    borderRadius: '10px',
    width: '520px',
    background: '#FAF8F4',
  },
  overlay: {
    zIndex: '10',
    background: 'rgba(13,13,12,0.8)',
  },
};
